document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('picture[role], picture[decoding], picture[fetchpriority]').forEach(function(pic) {
    pic.removeAttribute('role');
    pic.removeAttribute('decoding');
    pic.removeAttribute('fetchpriority');
  });
});
